import React, { createContext, useContext, useState, useEffect } from 'react';
import en from '../data/language_en.json';
import pt from '../data/language_pt.json';

const translations = { en, pt };

export const translate = (language, key) =>
  key.split('.').reduce((obj, part) => obj?.[part], translations[language]) || key;

// Components rendered outside the provider (isolated tests, portals) fall back to Portuguese.
const TranslationContext = createContext({
  t: (key) => translate('pt', key),
  changeLanguage: () => {},
  language: 'pt',
});

export const TranslationProvider = ({ children }) => {
  // Load saved language or fallback to 'pt'
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('appLanguage') || 'pt';
  });

  useEffect(() => {
    localStorage.setItem('appLanguage', language);
  }, [language]);

  // Supports nested keys like "clientsTable.matterName".
  const t = (key) => translate(language, key);

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <TranslationContext.Provider value={{ t, changeLanguage, language }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => useContext(TranslationContext);
